// Без дефолтов: язык домена задаётся только через env; не заданный домен -> ru.
// filter(Boolean) отбрасывает пустые элементы — пустая строка в includes() матчит любой hostname.
const parseDomains = value => (value || '')
  .split(',')
  .map(d => d.trim())
  .filter(Boolean);

const matchesDomain = (hostname, domain) => hostname === domain || hostname.endsWith(`.${domain}`);

const getDomainLanguage = hostname_override => {
  const hostname = hostname_override || (typeof window !== 'undefined' ? window.location.hostname : '');
  if (!hostname_override && ['127.0.0.1', 'localhost'].includes(hostname) && typeof window !== 'undefined') {
    const preview_language = new URLSearchParams(window.location.search).get('lang');
    if (['ru', 'uz', 'en'].includes(preview_language)) return preview_language;
  }
  const enDomains = parseDomains(process.env.REACT_APP_LANG_EN_DOMAINS);
  const uzDomains = parseDomains(process.env.REACT_APP_LANG_UZ_DOMAINS);
  // en проверяем раньше uz: специфичный поддомен (en.sportvokrug.com) должен сработать
  // до общего домена UZ (sportvokrug.com также соответствует его поддоменам)
  if (enDomains.some(d => matchesDomain(hostname, d))) return 'en';
  if (uzDomains.some(d => matchesDomain(hostname, d))) return 'uz';
  return 'ru';
};

export default getDomainLanguage;
